import * as Highcharts from "highcharts";
import { InformacionIBR } from "../entities/informacion-ibr";
import { Options } from "highcharts";
import { formatNumber, registerLocaleData } from '@angular/common';
import localeCo from '@angular/common/locales/es-CO'

registerLocaleData(localeCo, 'co-ES');

interface userOptionsExtended extends Highcharts.SeriesAbandsOptions {
    numeroDecimales: number;
    idPeriodicidad: number;
}

export class TablaDatosSerie {

    private obtenerMes(idMes: number) {
        if (idMes == 0) {
            return 'Enero';
        } else if (idMes == 1) {
            return 'Febrero';
        } else if (idMes == 2) {
            return 'Marzo';
        } else if (idMes == 3) {
            return 'Abril';
        } else if (idMes == 4) {
            return 'Mayo';
        } else if (idMes == 5) {
            return 'Junio';
        } else if (idMes == 6) {
            return 'Julio';
        } else if (idMes == 7) {
            return 'Agosto';
        } else if (idMes == 8) {
            return 'Septiembre';
        } else if (idMes == 9) {
            return 'Octubre';
        } else if (idMes == 10) {
            return 'Noviembre';
        } else {
            return 'Diciembre';
        }
    }

    private getColor() {
        var tiempoRealcontainer = document.getElementById('tiempoRealcontainer');
        if (tiempoRealcontainer != null) {
            return "910028";
        } else {
            return "008000";
        }
    }

    public graficarSerie(participante:InformacionIBR):any {
        return {
            chart: {
                type : 'column',
				borderColor : '#ececec',
				borderWidth : 1,
				marginBottom : 40,
				height : 200
            },
            exporting: {
                enabled: false
            },
            title : {
				text : participante.titulo,
                x: 0,
				style : {
                    align: "center",
					fontSize : '16px',
					fontWeight : 'bold',
					color : '#000000'
				}
			},
            subtitle : {
				text : participante.fecha
			},
            lang : {
				thousandsSep : ".",
				decimalPoint : ',',
				numericSymbolMagnitude : 1000
			},
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            // PROPIEDADES DEL EJE x
			xAxis : {
				categories : [ 'Nominal', 'Efectivo' ],
                title: {
                    text: ''
                }
			},
			// PROPIEDADES DEL EJE Y
			yAxis : {
				tickInterval : 0.1,
				gridLineWidth : 1,
				title : {
					text : participante.unidad,
					margin : 10,
					style : {
						fontSize : 11,
						fontWeight : 'bold',
						color : 'rgb(128, 128, 128)',
						fontFamily : 'tahoma, sans-serif'
					}
				},
				labels : {					
					style : {
						fontSize : 11,
						fontWeight : 'normal',
						color : 'rgb(51, 51, 51)',
					}
				}
			},
            tooltip : {
				valueDecimals : 3,
				valueSuffix : participante.unidad
			},          
            series : [{
                name : participante.titulo,
                data : [ participante.valorNominal, participante.valorEfectiva ],
                fecha : participante.fecha,
                color : participante.color
            }],
            plotOptions : {
				series : {
					borderColor : '#000000',
					dataLabels : {
						enabled : true,
						align : 'left',
						color : '#000000',
                        /**************************************************************************************************** */
                        /**************************EDITAR POR QUE SE GENERAR ERRRO EN LA ACTUALIZACIÓN*********************** */
                        /**************************************************************************************************** */
                        /*Highcharts.TooltipFormatterContextObject se cambió por Highcharts.Point*/
                        formatter: function(this: Highcharts.Point): string {
                            return formatNumber(Number(this.y), 'co-ES', '1.' + 3 + '-' + 3);
                        }
					}
				}
			}, 
            navigation : {
				menuItemHoverStyle : {
					background : '#ebeced',
					color : 'black'
				}
			},
			responsive : {
				rules : [ {
					condition : {
						maxWidth : 800,
						minHeight : 300,
						minWidth : 300
					}
				} ]
			},
			style : {
				width : '100%'
			}
        };
    }

    public getParticipantesDefault():Array<InformacionIBR>{
        let response:Array<InformacionIBR> = new Array();
        let plazos = [ ['overnight','overnight','Overnight'], ['1mes','1 mes','Un mes'], ['3mes','3 meses','Tres meses'], ['6mes','6 meses','Seis meses'], ['12mes','12 mese','Doce meses'] ];
        plazos.forEach(p => {
            let participante:InformacionIBR = new InformacionIBR();
            participante.id = p[0];
            participante.periodicidad = p[1];
            participante.titulo = p[2];
            participante.tablaIBR = {};
            response.push(participante);
        });
        return response;
    }
}